import { theme } from '../theme';
import { useBudget } from '../store/BudgetContext';
import { getWindow, HORIZONS, HorizonId } from '../utils/horizons';

interface Props {
  value: HorizonId;
  onChange: (id: HorizonId) => void;
}

export function HorizonSwitcher({ value, onChange }: Props) {
  const { viewData } = useBudget();
  const win = getWindow(value, { statsSince: viewData?.settings.stats_since ?? null });
  return (
    <div style={{ marginBottom: 18 }}>
      <div
        style={{
          display: 'flex',
          gap: 6,
          background: theme.colors.card,
          padding: 5,
          borderRadius: theme.radius.md,
          border: `1px solid ${theme.colors.line}`,
          marginBottom: 8,
        }}
      >
        {HORIZONS.map((h) => {
          const on = value === h.id;
          return (
            <button
              key={h.id}
              onClick={() => onChange(h.id)}
              style={{
                flex: 1,
                padding: '10px 0',
                borderRadius: 10,
                fontSize: 14,
                background: on ? theme.colors.ink : 'transparent',
                color: on ? theme.colors.paper : theme.colors.sub,
                transition: 'all .2s',
                border: 'none',
                cursor: 'pointer',
                fontFamily: theme.font,
              }}
            >
              {h.label}
            </button>
          );
        })}
      </div>
      <div style={{ textAlign: 'center', fontSize: 12, color: theme.colors.sub, letterSpacing: 0.4 }}>
        {win.label}
        {win.daysElapsed < win.daysTotal && (
          <span style={{ opacity: 0.7 }}>
            {' · '}
            {Math.round((win.daysElapsed / win.daysTotal) * 100)}% периода прошло
          </span>
        )}
      </div>
    </div>
  );
}
